import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ProductFlag } from "@tw/shared-ui-components/lib/components/productFlag/productFlag";
import { useRef } from "react";

import styles from "./miniCart.scss";
import { getRouter } from "../../utils/helper";
import { getLoggedInUserInfo } from "../../utils/helper";
import { formatNumber, formatAmount } from "../../utils/helper";
import {
  ONE_PLUS_N_BUNDLE,
  DEFAULT_BUNDLE,
  M_PLUS_N_BUNDLE,
  HOLDER_IMAGE,
} from "../../utils/constants";
import Strings from "../../utils/locale";

function miniCart({ headerData, headerRef }) {
  const { cartItemCount } = headerData || {};
  const miniCartRef = useRef();

  const router = getRouter();
  const miniCart = useSelector((state) => state?.headerState?.miniCart);
  const loggedInUserData = getLoggedInUserInfo();
  const miniCartAda = loggedInUserData.loginAda;

  // TODO: Add comment
  useEffect(() => {
    const headerBottom = headerRef?.current?.getBoundingClientRect()?.bottom;
    if (!miniCartRef.current) return;
    miniCartRef.current.style.top = `${headerBottom} !important`;
  }, [headerRef, miniCartRef]);

  // TODO: Add comment
  useEffect(() => {
    if (!miniCartRef.current) return;
    miniCartRef.current.style.opacity = 1;
  }, [miniCartRef, miniCart]);

  const getTopStyle = () => {
    // TODO: Add trace log

    const headerBottom = headerRef?.current?.getBoundingClientRect()?.bottom;
    return headerBottom;
  };

  const onClose = () => {
    // TODO: Add trace log

    document.getElementById("main-div").style.display = "none";
  };

  const onViewCart = () => {
    // TODO: Add trace log

    document.getElementById("main-div").style.display = "none";
    let parameter = router?.asPath;
    if (router) router.push(`/cart?p=${parameter.replace(/[?]+/g, '&')}`);
  };

  const renderContent = () => {
    // TODO: Add trace log

    // TODO: Move all data massaging logic to a separate method and assign to state variables thorugh setState. The render method should only be used to return JSX.

    // TODO: Replace map with reduce so that you do not have to use separate variable declaration and map method. Both can be combined into one statement.
    let totalPriceBulk = 0;
    miniCart?.products?.map(
      (ele) => (totalPriceBulk += ele?.product?.price * ele?.quantity || 0)
    );
    const formattdTotalprice = formatAmount(totalPriceBulk);

    // TODO: Replace map with reduce so that you do not have to use separate variable declaration and map method. Both can be combined into one statement.
    let totalPoints = 0;
    miniCart?.products?.map((ele) => (totalPoints += ele?.product?.point || 0));
    const formattedTotalPoints = formatNumber(totalPoints);

    // TODO: Replace map with reduce so that you do not have to use separate variable declaration and map method. Both can be combined into one statement.
    let totalSelectedProducts = 0;
    miniCart?.products?.map(
      (ele) => (totalSelectedProducts += ele?.quantity || 0)
    );

    const requiredProductImgsArray = miniCart?.products
      ?.slice(0, 4)
      ?.map((item, index) => {
        const addNum = miniCart?.products?.length - 3;
        if (index === 1) {
          return {
            ...item,
          };
        }
        if (index === 3 && addNum > 1) {
          return {
            ...item,
            lastItem: true,
            additionalNumber: `+${addNum}`,
          };
        }
        return {
          ...item,
          lastItem: false,
        };
      });

    // TODO: Instead of method make a separate component for this JSX
    const renderProductImgsTiles = () => (
      <div className={styles["bulkOrderImgs"]}>
        {requiredProductImgsArray?.map((item) => {
          return (
            <div className={styles["img-grid"]}>
              {item?.lastItem ? (
                <div className={styles["prod-img-container"]}>
                  <img
                    src={item?.product?.image ?? HOLDER_IMAGE}
                    className={styles["prod-img-op"]}
                    alt=""
                  />
                  <div className={styles["prod-img-overlay"]}>
                    {item?.additionalNumber}
                  </div>
                </div>
              ) : (
                <img
                  src={item?.product?.image ?? HOLDER_IMAGE}
                  alt=""
                  className={styles["prod-img"]}
                />
              )}
            </div>
          );
        })}
      </div>
    );

    // TODO: Instead of method make a separate component for this JSX
    const renderSingleProduct = () => (
      <>
        {miniCart?.adaNumber ? (
          miniCartAda === miniCart?.adaNumber ? (
            <div className={styles["bulkOrderName"]}>
              {miniCart?.adaName} {Strings.SELF}
            </div>
          ) : (
            <div className={styles["bulkOrderName"]}>{miniCart?.adaName}</div>
          )
        ) : null}
        <div className={styles["product-details"]}>
          <div className={styles["image"]}>
            <img
              className={styles["prod-image"]}
              src={miniCart?.products?.[0]?.product?.image}
              alt=""
            />
          </div>
          <div className={styles["product-des"]}>
            <div className={styles["prod-brand"]}>
              {miniCart?.products?.[0]?.product?.productBrand}
            </div>

            <div className={styles["prod-title"]}>
              {miniCart?.products?.[0]?.quantity} x
              {miniCart?.products?.[0]?.product?.productName}
            </div>
            <div className={styles["prod-flags"]}>
              <ProductFlag
                productFlags={miniCart?.products?.[0]?.product?.labels}
              />
            </div>
            {miniCart?.installment ? (
              <>
                <div className={styles["point-price"]}>
                  <span className={styles["prod-price"]}>
                    {formattdTotalprice}
                  </span>
                </div>
                <div className={styles["payment-intsallment"]}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles["installment"]}
                  >
                    <path
                      d="M8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25ZM8 1.75C11.4375 1.75 14.25 4.5625 14.25 8C14.25 11.4688 11.4375 14.25 8 14.25C4.53125 14.25 1.75 11.4688 1.75 8C1.75 4.5625 4.53125 1.75 8 1.75ZM12.375 5.84375L11.6562 5.125C11.5312 4.96875 11.2812 4.96875 11.125 5.125L6.71875 9.5L4.84375 7.625C4.6875 7.46875 4.46875 7.46875 4.3125 7.625L3.59375 8.3125C3.46875 8.46875 3.46875 8.71875 3.59375 8.84375L6.4375 11.7188C6.59375 11.875 6.8125 11.875 6.96875 11.7188L12.375 6.375C12.5 6.21875 12.5 5.96875 12.375 5.84375Z"
                      fill="#2C2C2C"
                    />
                  </svg>
                  {miniCart?.installment} {Strings.PAY}
                </div>
              </>
            ) : (
              <div className={styles["point-price"]}>
                <span className={styles["prod-price"]}>
                  {formattdTotalprice}
                </span>

                {miniCart?.id === "points" && totalPoints > 0 && (
                  <span className={styles["prod-price"]}>
                    + {formattedTotalPoints} {Strings.POINTS}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    );

    // TODO: Instead of method make a separate component for this JSX
    const renderBulkProduct = () => (
      <div>
        {miniCart?.adaNumber ? (
          miniCartAda === miniCart?.adaNumber ? (
            <div className={styles["bulkOrderName"]}>
              {miniCart?.adaName} {Strings.SELF}
            </div>
          ) : (
            <div className={styles["bulkOrderName"]}>{miniCart?.adaName}</div>
          )
        ) : null}
        {(miniCart?.id === ONE_PLUS_N_BUNDLE ||
          miniCart?.id === DEFAULT_BUNDLE ||
          miniCart?.id === M_PLUS_N_BUNDLE) && (
            <div className={styles["bundle"]}>{Strings.BUNDLE}</div>
          )}
        {renderProductImgsTiles()}
        <div className={styles["total-bulk-price"]}>{formattdTotalprice}</div>

        {miniCart?.id === ONE_PLUS_N_BUNDLE ? (
          <div className={styles["total-selected-products"]}>
            {miniCart?.products?.[0]?.quantity}
            <span className={styles["line-padding"]}>
              {miniCart?.products?.[0]?.quantity === 1
                ? Strings.SET_OF
                : Strings.SETS_OF}
            </span>

            <span className={styles["line-padding"]}>
              {miniCart?.products?.[0]?.product?.productBrand}
            </span>
          </div>
        ) : (
          <div className={styles["total-selected-products"]}>
            {totalSelectedProducts} {Strings.SELECTED_PRODUCTS}
          </div>
        )}
      </div>
    );

    return (
      <>
        {miniCart?.products?.length === 1
          ? renderSingleProduct()
          : renderBulkProduct()}
      </>
    );
  };

  if (!miniCart) return null;

  return (
    <div
      ref={miniCartRef}
      style={{ top: miniCart?.fixedTop ? miniCart?.fixedTop : getTopStyle() }}
      className={styles["main-container"]}
      id="main-div"
    >
      {/* TODO: Add comment */}
      <div className={styles["heading-close"]}>
        <div className={styles["heading"]}>{Strings.JUST_ADDED_MSGS}</div>
        <div className={styles["close"]} onClick={onClose}>
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.26643 9.93835L9.89826 9.30652C10.2471 8.95765 10.2471 8.39205 9.89826 8.0429L7.05536 5.2L9.89826 2.3571C10.2471 2.00825 10.2471 1.44263 9.89826 1.09348L9.26643 0.461653C8.91756 0.112782 8.35196 0.112782 8.00281 0.461653L5.15991 3.30456L2.31701 0.461653C1.96817 0.112782 1.40254 0.112782 1.05339 0.461653L0.421565 1.09348C0.0726944 1.44235 0.0726944 2.00795 0.421565 2.3571L3.26447 5.2L0.421565 8.0429C0.0726944 8.39175 0.0726944 8.95737 0.421565 9.30652L1.05339 9.93835C1.40226 10.2872 1.96817 10.2872 2.31701 9.93835L5.15991 7.09544L8.00281 9.93835C8.35166 10.2872 8.91756 10.2872 9.26643 9.93835Z"
              fill="#2C2C2C"
            />
          </svg>
        </div>
      </div>

      {/* TODO: Add comment */}
      {renderContent()}

      {/* View Cart CTA */}
      <div className={styles["btn-wrapper"]}>
        <div className={styles["btn"]} onClick={onViewCart}>
          {Strings.VIEW_CART} ({cartItemCount})
        </div>
      </div>
    </div>
  );
}

export default miniCart;
